import Rating from '@material-ui/lab/Rating';
import { withStyles } from '@material-ui/core/styles';

const StarRatings = ({value,precision}) => {
    const StyledRating = withStyles({
        iconFilled: {
            color: '#4096EF',
        },
    })(Rating);
    return (
        <>
            <StyledRating
                className="mtc-10"
                name="read-only"
                value={value}
                precision={precision}
                readOnly
            />
        </>
    )
}

export default StarRatings;